module.exports = __webpack_public_path__ + "media/Ringtone4.b654ca6d.mp3";